import React from 'react';

import { List, Icon, Table, Label, Popup, Image, Card, Button } from 'semantic-ui-react';
import _ from 'lodash';

import numeral from 'numeral';
import ThemeSelector from '../../themes/theme-selector';

const currentTheme = ThemeSelector.theme();

const hasNoAssets = array => _.isUndefined(_.find(array, i => i > 0));
const renderCurrency = () => _.constant('USD');
const priceFormatted = number => numeral(number).format('0,0[.]00');
const commaFormatted = (number, de = '-') => (number ? numeral(number).format('0,0') : de);


const getGrade = percentile => {
  if (percentile <= 0.1) return 'A+';
  if (percentile <= 0.2) return 'A';
  if (percentile <= 0.4) return 'B';
  if (percentile <= 0.6) return 'C';
  if (percentile <= 0.8) return 'D';
  return 'E';
};

const avatarStyle = {
  width: 100,
  height: 100,
};

const influencerNameStyle = {
  fontSize: 16,
  marginLeft: 8,
  marginBottom: -4,
  marginTop: 4,
  width: '150px',
};

const influnecerHandleStyle = {
  marginLeft: 8,
  marginTop: 3,
  color: 'gray',
};

const influnecerHandleStyle2 = {
  marginLeft: 8,
  marginTop: 3,
  color: 'gray',
};


const textBoldStyle = {
  fontWeight: 'bold',
};

const centeredText = null;
const SHOW_INFLUENCER_FEE = false;

const ReportTableHeader = ({ productDetails }) => (
  <Table.Header>
    <Table.HeaderCell>
      {productDetails ? 'product details' : 'influencer'}
    </Table.HeaderCell>
    <Table.HeaderCell>
      assets
    </Table.HeaderCell>
    {
      SHOW_INFLUENCER_FEE &&
      <Table.HeaderCell style={centeredText}>
        influencer <br />fee
      </Table.HeaderCell>
    }
    <Table.HeaderCell style={centeredText}>
      total <br />reach
    </Table.HeaderCell>
    <Table.HeaderCell style={centeredText}>
      <span>total <br />imps</span>
    </Table.HeaderCell>
    <Table.HeaderCell style={centeredText}>
      video <br />views
    </Table.HeaderCell>
    <Table.HeaderCell style={centeredText}>
      <Popup
        trigger={<span>total <br />engs</span>}
        content={<span>total engagements:<br /> likes + comments</span>}
      />
    </Table.HeaderCell>
    <Table.HeaderCell style={centeredText}>
      <Popup
        trigger={<span>CQS</span>}
        content="Content Quantity Score"
      />
    </Table.HeaderCell>
    <Table.HeaderCell style={centeredText}>
      ENG RATE%
    </Table.HeaderCell>
    <Table.HeaderCell style={centeredText}>
      RANK
    </Table.HeaderCell>
  </Table.Header>
);


const RowAssets = ({
  facebook,
  twitter,
  instagram,
  youtube,
  tiktok,
  telegram,
  discussionId,
}) => {
  const noAssets = hasNoAssets([
    facebook.count,
    instagram.images,
    instagram.videos,
    instagram.stories,
    instagram.carousels,
    instagram.igtvs,
    instagram.reels,
    twitter.count,
    youtube.count,
    tiktok.count,
  ]);
  const telegramCount = _.get(telegram, 'count', 0);
  const noContent = noAssets && telegramCount === 0;
  return (
    <List>
      {
        noContent && <List.Item><span style={{ color: 'gray' }}>NO CONTENT YET</span></List.Item>
      }
      { facebook && facebook.count > 0 &&
        <List.Item>{ facebook.count } x <Icon name="facebook" /> POST </List.Item>
      }
      { instagram && instagram.images > 0 &&
        <List.Item>{ instagram.images } x <Icon name="instagram" /> POST </List.Item>
      }
      { instagram && instagram.videos > 0 &&
        <List.Item>{ instagram.videos } x <Icon name="instagram" /> VIDEO </List.Item>
      }
      { instagram && instagram.stories > 0 &&
        <List.Item>{ instagram.stories } x <Icon name="instagram" /> STORY </List.Item>
      }
      {
        instagram && instagram.carousels > 0 &&
        <List.Item>{ instagram.carousels } x <Icon name="instagram" /> CAROUSEL </List.Item>
      }
      {
        instagram && instagram.igtvs > 0 &&
        <List.Item>{ instagram.igtvs } x <Icon name="instagram" /> IGTV </List.Item>
      }
      {
        instagram && instagram.reels > 0 &&
        <List.Item>{ instagram.reels } x <Icon name="instagram" /> REEL </List.Item>
      }
      { twitter && twitter.count > 0 &&
        <List.Item>{ twitter.count } x <Icon name="twitter" /> TWEET </List.Item>
      }
      { youtube && youtube.count > 0 &&
        <List.Item>{ youtube.count } x <Icon name="youtube" /> VIDEO </List.Item>
      }
      { tiktok && tiktok.count > 0 &&
        <List.Item>{ tiktok.count } x TT VIDEO </List.Item>
      }
      { telegram && telegram.count > 0 &&
        <List.Item>{ telegram.count } x <Icon name="telegram plane" /> TELEGRAM</List.Item>
      }
      {
        !noContent &&
        <a
          rel="noopener noreferrer"
          href={`${currentTheme.shareSite}/collab/${discussionId}/campaign`}
          target="_blank"
        >
        view content...
        </a>
      }
    </List>
  );
};


const ReportRow = ({
  id,
  name,
  thumbnail,
  influencerName,
  instagramCount,
  budget,
  derivedFee,
  inventoryItems = [],
  currency,
  totals: { reach, impressions, engagements, videoViews },
  costs: { costPerEngagement, impressionsCPM, reachCPM, viewsCPM, engsCPM },
  trackedAssetsStats,
  contentQuantityRank,
  contentQuantityScore,
  totalInfluencers,
  productDetails,
  discussionId,
}) => {
  const percentile = contentQuantityRank / totalInfluencers;
  const grade = getGrade(percentile);

  const {
    instagram,
  } = trackedAssetsStats;

  const engageableContentCount = _.sum([instagram.reels,
    instagram.igtvs,
    instagram.videos,
    instagram.carousels, instagram.images]);

  let imageUrl;
  if (productDetails) {
    imageUrl = productDetails.imageUrl;
  } else {
    imageUrl = thumbnail;
  }
  const engagementRate = (engagements / (engageableContentCount * instagramCount)) * 100;
  return (
    <Table.Row key={id}>
      <Table.Cell style={{ backgroundColor: '#EEE' }} width="4">
        <table>
          <tr>
            <td>
              <Image
                src={imageUrl}
                className="circular"
                style={avatarStyle}
                size="large"
              />
            </td>
            <td>
              <div style={influencerNameStyle}>{ productDetails ? productDetails.name : influencerName }</div>
              <br />
              <div style={influnecerHandleStyle}>{ productDetails ? `Gift RRP: ${productDetails.retailPrice}` : name }</div>
              {
                productDetails && false &&
                <div style={influnecerHandleStyle2}>Gift Value: {productDetails.internalPrice}</div>
              }
            </td>
          </tr>
        </table>


      </Table.Cell>
      <Table.Cell width="3">
        <RowAssets {...trackedAssetsStats} discussionId={discussionId} />
      </Table.Cell>

      {
        SHOW_INFLUENCER_FEE &&
        <Table.Cell textAlign="center">
          {
            _.isEmpty(inventoryItems) && budget > 0 &&
            <span>{ `${renderCurrency(currency)} ${priceFormatted(budget)}` }</span>
          }
          { _.isEmpty(inventoryItems) && !budget && '-' }
          {
            !_.isEmpty(inventoryItems) &&
            <Table basic="very" collapsing>
              <Table.Row>
                <Table.Cell>Fee</Table.Cell>
                <Table.Cell>{ renderCurrency(currency)} {priceFormatted(budget)}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Gifts</Table.Cell>
                <Table.Cell>
                  <List textAlign="left">
                    { _.map(inventoryItems, item =>
                      <List.Item>
                        {_.get(item, 'value')} ({ renderCurrency(currency)} { _.get(item, 'monetaryValue') })
                      </List.Item>)
                    }
                  </List>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell style={textBoldStyle}>Total</Table.Cell>
                <Table.Cell style={textBoldStyle}>{ renderCurrency(currency)} {derivedFee}</Table.Cell>
              </Table.Row>
            </Table>
          }
        </Table.Cell>
      }

      <Table.Cell textAlign="center" width="1">
        { reach ? commaFormatted(reach) : '-' }
      </Table.Cell>
      <Table.Cell textAlign="center" width="1">
        { impressions ? commaFormatted(impressions) : '-' }
      </Table.Cell>
      <Table.Cell textAlign="center" width="1">
        { videoViews ? commaFormatted(videoViews) : '-' }
      </Table.Cell>
      <Table.Cell textAlign="center" width="1">
        { engagements ? commaFormatted(engagements) : '-' }
      </Table.Cell>
      <Table.Cell textAlign="center" width="1">
        <Label circular color="pink">{ contentQuantityScore }</Label>
      </Table.Cell>
      <Table.Cell textAlign="center" width="1">
        { engagementRate ? `${engagementRate.toFixed(2)}%` : '-' }
      </Table.Cell>
      <Table.Cell textAlign="center" width="1">
        <p>{contentQuantityRank}/{totalInfluencers}</p>
        <p><Label>{grade}</Label></p>
      </Table.Cell>
    </Table.Row>
  );
};

const NoSummaryCard = ({ name, id, createdBy, liveDateString, endDateString, router }) => (
  <Card fluid>
    <Card.Content>

      <table width="100%">
        <tr>
          <td>
            <h4>{name}</h4>
            <p style={{ color: 'grey' }}><strong>campaign owner: </strong> {createdBy}</p>

          </td>
          <td style={{ color: 'gray' }}>
            <p>live date: {liveDateString}</p>
            <p>end date: {endDateString}</p>
          </td>
          <td>
            <Popup
              trigger={
                <Button
                  floated="right"
                  circular
                  inverted
                  color="green"
                  icon="external alternate"
                  onClick={() => window.open(`/campaign/${id}/collaborations`, '_blank')}
                />
              }
              content={`Open the ${name} campaign in a new tab.`}
            />
            <Popup
              trigger={
                <Button
                  floated="right"
                  circular
                  inverted
                  color="pink"
                  icon="arrow alternate circle right"
                  onClick={() => router.push(`/campaign/${id}/collaborations`)}
                />
              }
              content={`Open the ${name} campaign.`}
            />

          </td>
        </tr>
      </table>

    </Card.Content>
    <Card.Content>
      <span>No content summary available</span>
    </Card.Content>
  </Card>
);
module.exports = {
  ReportRow,
  ReportTableHeader,
  NoSummaryCard,
};



/** WEBPACK FOOTER **
 ** ./src/components/influencer-campaigns/components.js
 **/